import(/* webpackMode: "eager" */ "/app/app/employer/page.tsx");
